module.exports = __webpack_public_path__ + "media/5271-loading-4.7de4f3c2.mp4";